module.exports = __webpack_public_path__ + "img/hero.93bdcb8b.png";